// Celebratory unlock toast — animates a badge or trophy onto the screen.
// Uses sonner toast as the host so it stacks gracefully with other notifications.
import { toast } from 'sonner';
import React from 'react';

const TROPHY_META = {
  bronze:   { icon: '🥉', name: 'Bronze Deskey Plaque',   color: '#CD7F32' },
  silver:   { icon: '🥈', name: 'Silver Deskey Plaque',   color: '#C0C0C0' },
  gold:     { icon: '🥇', name: 'Gold Deskey Plaque',     color: '#FFD700' },
  platinum: { icon: '💎', name: 'Platinum Deskey Trophy', color: '#E5E4E2' },
};

export function showBadgeToast(badge) {
  toast.custom((id) => (
    <div className="flex items-center gap-3 rounded-2xl shadow-2xl px-4 py-3 border-2 max-w-sm animate-[slidein_0.4s_ease-out]"
      style={{ background: 'var(--st-card,#fff)', borderColor: 'var(--st-primary,#34A853)' }}
      data-testid={`unlock-toast-${badge.badge_id || badge.id}`}>
      <div className="text-3xl flex-shrink-0">{badge.icon}</div>
      <div className="min-w-0">
        <div className="text-[10px] font-bold uppercase tracking-widest" style={{ color: 'var(--st-primary,#34A853)' }}>Badge unlocked</div>
        <div className="text-sm font-extrabold truncate">{badge.name}</div>
        <div className="text-[11px] opacity-70 truncate">{badge.desc}</div>
      </div>
      <button onClick={() => toast.dismiss(id)} className="text-xs opacity-50 hover:opacity-100 px-1">×</button>
    </div>
  ), { duration: 5000 });
}

export function showTrophyToast(trophyId) {
  const meta = TROPHY_META[trophyId];
  if (!meta) return;
  toast.custom((id) => (
    <div className="flex items-start gap-3 rounded-2xl shadow-2xl px-4 py-4 border-2 max-w-md animate-[slidein_0.5s_ease-out]"
      style={{ background: 'linear-gradient(135deg, var(--st-card,#fff) 0%, ' + meta.color + '22 100%)', borderColor: meta.color }}
      data-testid={`trophy-toast-${trophyId}`}>
      <div className="text-5xl flex-shrink-0">{meta.icon}</div>
      <div className="min-w-0">
        <div className="text-[10px] font-bold uppercase tracking-widest" style={{ color: meta.color }}>🎉 Milestone trophy</div>
        <div className="text-base font-extrabold leading-snug">{meta.name} unlocked!</div>
        <div className="text-[11px] opacity-80 mt-1">Claim it from the Badges page — we'll mail your physical plaque to your home!</div>
      </div>
      <button onClick={() => toast.dismiss(id)} className="text-xs opacity-50 hover:opacity-100 px-1">×</button>
    </div>
  ), { duration: 9000 });
}

// Inject keyframe once
if (typeof document !== 'undefined' && !document.getElementById('__deskey_unlock_kf')) {
  const s = document.createElement('style');
  s.id = '__deskey_unlock_kf';
  s.textContent = '@keyframes slidein { 0%{transform:translateX(40px) scale(0.9);opacity:0} 100%{transform:translateX(0) scale(1);opacity:1} }';
  document.head.appendChild(s);
}
